import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &:first-child {\n    margin-left: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { IconButton } from "@miro-site/core";
import styled from "styled-components";
import theme from "./theme";
import { AppStore, GooglePlay, LogoSquare } from "@miro-site/core";
var icons = {
    appStore: /*#__PURE__*/ _jsx(AppStore, {
        width: [
            123,
            144,
            134,
            134,
            144
        ],
        height: [
            42,
            48,
            45,
            45,
            48
        ]
    }),
    googlePlay: /*#__PURE__*/ _jsx(GooglePlay, {
        width: [
            139,
            162,
            152,
            152,
            162
        ],
        height: [
            42,
            48,
            45,
            45,
            48
        ]
    }),
    miroLogo: /*#__PURE__*/ _jsx(LogoSquare, {
        width: [
            42,
            48,
            45,
            45,
            48
        ],
        height: [
            42,
            48,
            45,
            45,
            48
        ]
    })
};
var Icon = styled(IconButton).attrs({
    $styles: {
        marginLeft: theme.footer.icon.margin.left
    }
}).withConfig({
    componentId: "sc-74c5fa3e-0"
})(_templateObject());
var FooterIcons = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: icons.appStore,
                label: "App Store",
                href: "https://apps.apple.com/us/app/miro-collaborative-whiteboard/id1180074773?from=footer_menu&source=miro_website",
                title: "App Store"
            }),
            /*#__PURE__*/ _jsx(Icon, {
                icon: icons.googlePlay,
                label: "Google Play",
                href: "https://play.google.com/store/apps/details?id=com.realtimeboard&from=footer_menu&source=miro_website",
                title: "Google Play"
            }),
            /*#__PURE__*/ _jsx(Icon, {
                icon: icons.miroLogo,
                label: "Miro",
                href: "https://miro.com/",
                title: "Miro"
            })
        ]
    });
};
export default FooterIcons;
